<aside
  class="fixed flex flex-col px-5 left-0 bg-[var(--pc-sidebar-bg)] border-r border-[var(--pc-sidebar-border)] text-[var(--pc-text-main)] transition-all duration-300 ease-in-out z-[102] xl:top-0 xl:h-screen"
  [ngClass]="{
    'w-[290px]':
      (isExpanded$ | async) || (isMobileOpen$ | async) || (isHovered$ | async),
    'w-[90px]': !(
      (isExpanded$ | async) ||
      (isMobileOpen$ | async) ||
      (isHovered$ | async)
    ),
    'translate-x-0': isMobileOpen$ | async,
    '-translate-x-full': !(isMobileOpen$ | async),
    'xl:translate-x-0': true
  }"
  [ngStyle]="getSidebarStyle()"
  (mouseenter)="onSidebarMouseEnter()"
  (mouseleave)="sidebarService.setHovered(false)"
>
  <div
    class="py-6 xl:py-8 flex transition-all duration-300 ease-in-out"
    [ngClass]="{
      'xl:justify-center': !((isExpanded$ | async) || (isHovered$ | async)),
      'justify-start pl-2': (isExpanded$ | async) || (isHovered$ | async)
    }"
  >
    <a routerLink="/inicio" class="flex items-center no-underline select-none">
      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
        <img
          class="image-logo-general dark:hidden"
          [ngSrc]="imgLogoLight"
          alt="Logo"
          width="158"
          height="48"
          priority
        />
        <img
          class="image-logo-general hidden dark:block"
          [ngSrc]="imgLogoDark"
          alt="Logo"
          width="158"
          height="48"
          priority
        />
      } @else {
        <div class="flex items-center justify-center w-[72px] h-12">
          <img
            class="dark:hidden"
            [ngSrc]="imgLogoIconLight"
            alt="Logo"
            width="72"
            height="45"
            priority
          />
          <img
            class="hidden dark:block"
            [ngSrc]="imgLogoIconDark"
            alt="Logo"
            width="72"
            height="45"
            priority
          />
        </div>
      }
    </a>
  </div>

  <!-- Buscador del menú (solo visible con el sidebar expandido) -->
  @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
    <div class="sidebar-search mb-5">
      <div class="relative">
        <span
          class="pointer-events-none absolute inset-y-0 left-0 flex w-11 items-center justify-center text-gray-400 dark:text-gray-500"
        >
          <i class="bi bi-search text-[15px]"></i>
        </span>
        <input
          #sidebarSearchInput
          type="text"
          [value]="searchQuery()"
          (input)="onSearchInput($event)"
          (keydown)="onSearchKeydown($event)"
          [placeholder]="'sidebar.search.placeholder' | transloco"
          [attr.aria-label]="'sidebar.search.aria' | transloco"
          autocomplete="off"
          spellcheck="false"
          class="h-11 w-full rounded-lg border border-gray-200 bg-gray-50 pl-11 pr-16 text-sm text-gray-800 outline-none transition-colors placeholder:text-gray-400 focus:border-brand-400 focus:bg-white focus:ring-2 focus:ring-brand-500/20 dark:border-gray-800 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500 dark:focus:border-brand-500 dark:focus:bg-gray-900"
        />
        @if (isSearching()) {
          <button
            type="button"
            (click)="clearSearchAndFocus()"
            [attr.aria-label]="'sidebar.search.clear' | transloco"
            class="absolute inset-y-0 right-2.5 my-auto flex h-6 w-6 items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-600 dark:hover:bg-gray-700 dark:hover:text-gray-200"
          >
            <i class="bi bi-x-lg text-[13px]"></i>
          </button>
        } @else {
          <kbd
            class="pointer-events-none absolute inset-y-0 right-2.5 my-auto hidden h-5 select-none items-center gap-1 rounded border border-gray-200 bg-white px-1.5 font-sans text-[10px] font-medium tracking-wide text-gray-400 xl:flex dark:border-gray-700 dark:bg-gray-900 dark:text-gray-500"
          >
            {{ shortcutHint }}
          </kbd>
        }
      </div>
    </div>
  }

  <div class="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar">

    <!-- Resultados de búsqueda (lista plana tipo command-palette) -->
    @if (isSearching()) {
      <nav class="mb-6" aria-live="polite">
        @let results = searchResults();
        @if (results.length) {
          <ul class="flex flex-col gap-1">
            @for (res of results; track res.module.id; let i = $index) {
              <li [id]="'sb-search-result-' + i">
                <a
                  [routerLink]="res.module.url"
                  (click)="onResultClick()"
                  class="menu-dropdown-item items-start !py-2.5"
                  [ngClass]="{
                    'menu-dropdown-item-active': i === activeResultIndex() || isActive(res.module.url),
                    'menu-dropdown-item-inactive': i !== activeResultIndex() && !isActive(res.module.url)
                  }"
                >
                  <span
                    class="menu-item-icon-size-system mt-0.5 shrink-0"
                    aria-hidden="true"
                  >
                    <i [class]="'bi ' + res.category.icon"></i>
                  </span>
                  <span class="flex min-w-0 flex-col">
                    <span class="truncate">
                      @for (part of highlightParts(moduleLabel(res.module)); track $index) {
                        <span [class.sidebar-search-hl]="part.match">{{ part.text }}</span>
                      }
                      @if (res.group.system) {
                        <span class="system-identificador-menu">SYS</span>
                      }
                    </span>
                    <span class="truncate text-xs font-normal text-gray-400 dark:text-gray-500">
                      {{ ('sidebar.search.in' | transloco) }} {{ categoryLabel(res.category) }}
                    </span>
                  </span>
                </a>
              </li>
            }
          </ul>
        } @else {
          <div class="flex flex-col items-center gap-1 px-4 py-8 text-center">
            <i class="bi bi-search text-2xl text-gray-300 dark:text-gray-600"></i>
            <p class="mt-1 text-sm font-medium text-gray-500 dark:text-gray-400">
              {{ 'sidebar.search.noResults' | transloco: { query: searchQuery() } }}
            </p>
            <p class="text-xs text-gray-400 dark:text-gray-500">
              {{ 'sidebar.search.noResultsHint' | transloco }}
            </p>
          </div>
        }
      </nav>
    }

    <nav class="mb-6" [class.hidden]="isSearching()">
      <div class="flex flex-col gap-4">
        <!-- NavMenu Section -->
          @for (group of sidebarData?.groups; track group.id) {
            <div>
              <h2
                class="modulo-grupo mb-4 text-xs uppercase flex leading-[20px] text-gray-400"
                [ngClass]="{
                  'xl:justify-center': !(
                    (isExpanded$ | async) || (isHovered$ | async)
                  ),
                  'justify-start': (isExpanded$ | async) || (isHovered$ | async)
                }"
              >
                @if (
                  (isExpanded$ | async) || 
                  (isHovered$ | async) || 
                  (isMobileOpen$ | async)
                ) { 
                  {{ groupLabel(group) }}
                }
                @else {
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="size-6"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                }
              </h2>
  
              <ul class="flex flex-col gap-1">
                @for (ctg of group.categories; track ctg.id) {
                  @let categoryId = getCategoryId(group.id, ctg.id);
                  <li>
                    <button
                      (click)="toggleSubmenu(categoryId)"
                      class="menu-item group cursor-pointer"
                      [class.menu-item-active]="openSubmenu === categoryId"
                      [class.menu-item-inactive]="openSubmenu !== categoryId"
                      [ngClass]="{
                        'xl:justify-center': !(
                          (isExpanded$ | async) || (isHovered$ | async)
                        ),
                        'xl:justify-start':
                          (isExpanded$ | async) || (isHovered$ | async)
                      }"
                    >
                      <span
                        class="menu-item-icon-size menu-item-icon-size-system"
                        [class.menu-item-icon-active]="openSubmenu === categoryId"
                        [class.menu-item-icon-inactive]="openSubmenu !== categoryId"
                      >
                      <i [class]="'bi ' + ctg.icon"></i>
                      </span>

                      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                        <span class="menu-item-text"> {{ categoryLabel(ctg) }} </span>
                        @if(group.system){
                          <app-badge variant="light" color="primary"> SYS </app-badge>
                        }
                      }

                      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                        <svg
                          [ngClass]="{
                            'rotate-180 text-brand-500': openSubmenu === categoryId
                          }"
                          width="1em"
                          height="1em"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="ml-auto w-5 h-5 transition-transform duration-200"
                        >
                          <path
                            d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      }
                    </button>

                    <div
                      #subMenu
                      class="overflow-hidden transition-all duration-300"
                      [id]="categoryId"
                      [style.display]="
                        (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)
                          ? 'block'
                          : 'none'
                      "
                      [ngStyle]="{
                        height:
                          openSubmenu === categoryId
                            ? (subMenuHeights[categoryId] || 0) + 'px'
                            : '0px'
                      }"
                    >
                      <ul class="mt-2 space-y-1 ml-9">
                        @for (mod of ctg.modules; track mod.id) {
                        <li>
                          <a
                            [routerLink]="mod.url"
                            routerLinkActive="menu-dropdown-item-active"
                            (click)="onSubmenuClick()"
                            class="menu-dropdown-item"
                            [ngClass]="{
                              'menu-dropdown-item-inactive': !isActive(mod.url),
                              'menu-dropdown-item-active': isActive(mod.url)
                            }"
                          >
                            {{ moduleLabel(mod) }}
                            @if(group.system){
                              <span class="system-identificador-menu">
                                SYS
                              </span>
                            }
                          </a>
                        </li>
                        }
                      </ul>
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
        <!-- end NavMenu Section -->
      </div>
    </nav>

  </div>
</aside>